// extracted by mini-css-extract-plugin
module.exports = {"container":"styled_container__15ELt","error_Section":"styled_error_Section__Cu6wo","device_selector":"styled_device_selector__1XUQE","device":"styled_device__1XWP5"};